import {Ventrata} from 'types'

export const getUnitMap = (option: Ventrata.Option) => {
  return option.units.reduce((acc, unit) => {
    acc[unit.type] = unit.id
    return acc
  }, {} as Record<string, string>)
}
